import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
// import NewsDetailsPage from "./NewsDetailsPage";
import NewsListingPage from "./NewsListingPage";
// import NewsPage from "./NewsPage";
import {
  withPermission,
  Roles,
} from "../../../util/PermissionProvider";
import EditNewsPage from "./EditNewsPage";
import AddNewsPage from "./AddNewsPage";

export default function NewsManagementPage(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}`}
        component={withPermission(
          NewsListingPage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/create`}
        component={withPermission(
          AddNewsPage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/:newsId`}
        component={withPermission(
          EditNewsPage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}`} />} />
    </Switch>
  );
}
